import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Radio from 'bloko/blocks/radio';
import Checkbox from 'bloko/blocks/checkbox';
import dataQa from 'bloko/blocks/treeSelector/dataQa';
import Icon, { IconDynamic, IconLink } from 'bloko/blocks/icon';
import Keyboard from 'bloko/common/constants/keyboard';
import Supports from 'bloko/common/supports';

export default class TreeSelectorElement extends PureComponent {
    handleInputChange = (event) => {
        const { id, onChange } = this.props;
        onChange(id, event.target.checked);
    };

    handleCheckboxClickForIE = () => {
        const { id, indeterminate, onChange } = this.props;
        indeterminate && onChange(id, true);
    };

    handleExpandableClick = () => {
        const { id, onExpansion } = this.props;
        onExpansion(id);
    };

    handleExandableKeyDown = (event) => {
        const { id, expanded, onExpansion } = this.props;
        switch (event.keyCode) {
            case Keyboard.KEY_CODES.ARROW_LEFT:
                expanded && onExpansion(id);
                event.preventDefault();
                break;
            case Keyboard.KEY_CODES.ARROW_RIGHT:
                !expanded && onExpansion(id);
                event.preventDefault();
                break;
        }
    };

    renderIcon() {
        const { hasAction, hasChildren, expanded } = this.props;
        const nonActionProps = hasAction ? {} : { tabIndex: '0', onKeyDown: this.handleExandableKeyDown };
        return (
            hasChildren && (
                <span className="bloko-tree-selector-item-spacer">
                    <IconDynamic>
                        <IconLink
                            Element="span"
                            onClick={this.handleExpandableClick}
                            data-qa={dataQa.toggle}
                            {...nonActionProps}
                        >
                            <Icon
                                view={expanded ? Icon.views.chevronDown : Icon.views.chevronRight}
                                initial={Icon.kinds.action}
                                highlighted={Icon.kinds.impact}
                            />
                        </IconLink>
                    </IconDynamic>
                </span>
            )
        );
    }

    renderAction() {
        const { id, name, hasAction, disabled, selected, indeterminate, singleChoice, children } = this.props;
        if (!hasAction) {
            return null;
        }

        const inputProps = {
            disabled,
            checked: selected,
            onChange: this.handleInputChange,
            onKeyDown: this.handleExandableKeyDown,
            'data-qa': dataQa.input,
        };

        const isIE = Supports.IE() || Supports.IEMobile();
        const propsForIE = isIE ? { onClick: this.handleCheckboxClickForIE } : {};

        return singleChoice ? (
            <Radio {...inputProps} name={`${name}-${id}`}>
                {children}
            </Radio>
        ) : (
            <Checkbox {...inputProps} {...propsForIE} name={name} indeterminate={indeterminate}>
                {children}
            </Checkbox>
        );
    }

    renderText() {
        const { hasAction, hasChildren, children } = this.props;
        if (hasAction) {
            return null;
        }
        if (hasChildren) {
            return (
                <div
                    className="bloko-tree-selector-item__text"
                    data-qa={dataQa.text}
                    onClick={this.handleExpandableClick}
                >
                    {children}
                </div>
            );
        }
        return children;
    }

    render() {
        return (
            <div className="bloko-tree-selector-content">
                {this.renderIcon()}
                {this.renderAction()}
                {this.renderText()}
            </div>
        );
    }

    static propTypes = {
        /** ID элемента. */
        id: PropTypes.string,
        /** Имя элемента. */
        name: PropTypes.string,
        /** Элемент с инпутом. */
        hasAction: PropTypes.bool,
        /** Разрешает выбор только одного элемента. */
        singleChoice: PropTypes.bool,
        /** Элемент с потомками. */
        hasChildren: PropTypes.bool,
        /** Элемент выбран. */
        selected: PropTypes.bool,
        /** Элемент открыт. */
        expanded: PropTypes.bool,
        /** Элемент запрещён. */
        disabled: PropTypes.bool,
        /** Значение инпута не определено. */
        indeterminate: PropTypes.bool,
        /** Обработчик изменения. В аргументах получает `{String} id`, `{Boolean} isSelected`. */
        onChange: PropTypes.func,
        /** Обработчик открытия/закрытия элемента. В аргументах получает `{String} id`. */
        onExpansion: PropTypes.func,
    };

    static defaultProps = {
        id: null,
        name: null,
        hasAction: false,
        singleChoice: false,
        hasChildren: false,
        selected: false,
        expanded: false,
        disabled: false,
        indeterminate: false,
        onChange: () => {},
        onExpansion: () => {},
    };
}
